module.exports = __webpack_public_path__ + "img/logo-white.aa5c0b51.png";